import {
  LOAD,
  UPDATE,
  CREATE,
  UPDATE_PAL_CONFIG,
  CREATE_PAL_CONFIG,
  CREATE_PAL_CORE_DIRECT,
} from 'model/fspConfigPayALoan';
import {
  load,
  update,
  create,
  update as updatePalConfig,
  create as createPalConfig,
  PAL_DUPLICATE_SUBDOMAIN_EXISTS_REASON,
  PAL_DUPLICATE_SUBDOMAIN_IN_PAYLOAD_REASON,
} from 'sdk/fspConfigPayALoan';
import { takeLatest } from 'redux-saga/effects';
import { callAction, ORM } from '../util';
import { loadFSPProfileAction } from './export';

const isDuplicatePalSubdomainReason = (reason) =>
  reason === PAL_DUPLICATE_SUBDOMAIN_IN_PAYLOAD_REASON ||
  reason === PAL_DUPLICATE_SUBDOMAIN_EXISTS_REASON;

const formatPalConfigErrorMessage = (errorObj) => {
  const status =
    errorObj?.status ?? errorObj?.statusCode ?? errorObj?.response?.status;
  const reason =
    errorObj?.error?.reason || errorObj?.response?.data?.error?.reason;
  const detail =
    errorObj?.error?.detail || errorObj?.response?.data?.error?.detail;
  const message = errorObj?.message || errorObj?.error?.message;

  if (status === 412 || status === '412') {
    if (isDuplicatePalSubdomainReason(reason)) {
      return {
        error: true,
        message: detail || message || null,
      };
    }

    return null;
  }

  return {
    error: true,
    message: message || 'An error occurred',
  };
};

export const createFspPalConfig = () =>
  callAction({
    api: create,
    dataName: ORM,
    formatErrorMessage: formatPalConfigErrorMessage,
    formatSuccessMessage: () => `FSP Config has been successfully created`,
    type: CREATE,
  });

export const createPalCoreDirect = () =>
  callAction({
    api: create,
    dataName: ORM,
    formatSuccessMessage: () => `FSP Config has been successfully created`,
    type: CREATE_PAL_CORE_DIRECT,
  });

const updateFspPalConfig = () =>
  callAction({
    api: update,
    dataName: ORM,
    formatSuccessMessage: () => `Pay a Loan Config successfully updated`,
    type: UPDATE,
  });

function* updateAndPopulateExport(action) {
  const updateAction = updateFspPalConfig();

  if (yield updateAction(action)) {
    yield loadFSPProfileAction(action);
  }
}

export default function* saga() {
  yield takeLatest(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeLatest(
    UPDATE_PAL_CONFIG.ACTION,
    callAction({
      api: updatePalConfig,
      dataName: ORM,
      type: UPDATE_PAL_CONFIG,
      formatSuccessMessage: () => `Pay a Loan Config successfully updated`,
      formatErrorMessage: formatPalConfigErrorMessage,
    })
  );

  yield takeLatest(
    CREATE_PAL_CONFIG.ACTION,
    callAction({
      api: createPalConfig,
      dataName: ORM,
      type: CREATE_PAL_CONFIG,
      formatSuccessMessage: () => `Pay a Loan Config successfully created`,
      formatErrorMessage: formatPalConfigErrorMessage,
    })
  );

  yield takeLatest(CREATE_PAL_CORE_DIRECT.ACTION, createPalCoreDirect);
  yield takeLatest(CREATE.ACTION, createFspPalConfig);
  yield takeLatest(UPDATE.ACTION, updateAndPopulateExport);
}
